module.exports = __webpack_public_path__ + "img/hr-puberty-decal-23.735be614.png";